import { httpUrl } from "./httpUrl";

let baseUrl = `${httpUrl.host}/gy-apartment`;
let baseUrl2 = `${httpUrl.host}/gy-apartment`;

let api = {
  // 概览
  getVenueOverview: `${baseUrl}/venueOverview/getVenueOverview`,

  getVenueConsumptionRecordStatictics: `${baseUrl}/venueOverview/getVenueConsumptionRecordStatictics`,

  getVenuePlaceBookingRecordStatictics: `${baseUrl}/venueOverview/getVenuePlaceBookingRecordStatictics`,

  // 设施管理——分页
  getEquipmentPage: `${baseUrl}/equipment/getPage`,

  // 设施管理——添加
  addEquipment: `${baseUrl}/equipment/add`,

  // 设施管理——详情
  getEquipmentByCode: `${baseUrl}/equipment/getByCode`,

  // 设施管理——修改
  updateEquipment: `${baseUrl}/equipment/update`,

  // 设施管理——删除
  deleteEquipmentByCodes: `${baseUrl}/equipment/deleteByCodes`,

  // 设施管理——列表
  getEquipmentList: `${baseUrl}/equipment/getList`,

  // 获取场地分页
  getPlacePage: `${baseUrl}/place/getPage`,

  // 添加场地
  addPlace: `${baseUrl}/place/add`,

  // 删除场地
  deletePlaceByCodes: `${baseUrl}/place/deleteByCodes`,

  // 查询场地详情
  getPlaceByCode: `${baseUrl}/place/getByCode`,

  // 修改场地详情
  updatePlaceByCode: `${baseUrl}/place/update`,

  // 场地列表
  getPlaceList: `${baseUrl}/place/getList`,

  // 获取预约记录分页
  getPlaceBookingPage: `${baseUrl}/placeBooking/getPage`,

  // 获取预约记录详情
  getPlaceBookingByCode: `${baseUrl}/placeBooking/getByCode`,

  // 取消预约
  bookingCancel: `${baseUrl}/placeBooking/bookingCancel`,

  // 导出缴费记录
  exportPlaceBooking: `${baseUrl}/placeBooking/export`,

  // 预约账单
  getBillPage: `${baseUrl}/bill/getPage`,

  // 预约账单详情
  getBillByCode: `${baseUrl}/bill/getByCode`,

  // 预约账单修改
  updateBill: `${baseUrl}/bill/update`,

  // 获取园区责任人
  getResponsiblePersonList: `${baseUrl2}/person/getYqPersonList`,

  // 获取楼栋列表
  getBuildingList: `${baseUrl2}/building/getBuildingList`,

  // 上传图片
  uploadImg: `${baseUrl2}/yqNews/uploadImg`
};

export { api };



// WEBPACK FOOTER //
// ./src/view/api/SiteReservation.js